import React from 'react';
import classNames from 'classnames';
import { ButtonBack } from 'pure-react-carousel';
import { ArrowNextIcon } from '../../icons';
import css from './ListingCardsCarousel.css';

const CarouselButtonPrev = ({
    show = true,
    renderContent = null,
    hideOnStartEnd = false,
    className = null,
}) => {
    const rootClassNames = classNames(css.sliderButton, css.sliderButtonBack, className);

    if (typeof renderContent === 'function') {
        return renderContent({ rootClassNames });
    }

    if (!show) return null;

    return (
        <ButtonBack
            className={classNames(rootClassNames, {
                [css.hideOnStartEnd]: hideOnStartEnd,
            })}
        >
            <ArrowNextIcon />
        </ButtonBack>
    );
};

export default CarouselButtonPrev;
